<template lang="pug">
  header.headerQuestions
    .categoryItem
      i.fas.fa-shield-alt.categoryItem-icon
    ul.numberQuestions
      li.numberQuestions-item(v-for="question in totalQuestions", :key="question.index", :class="{active: question.index == questionIndex}") {{ question.index + 1 }}
        span.activeText(v-if="question.index == questionIndex") Atual
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'TheHeaderQuestions',
  computed: {
    ...mapGetters({ questions: 'coaching/currentQuestions' }),
    questionIndex() {
      return parseInt(this.$route.params.questionIndex)
    },
    totalQuestions() {
      const { questions, questionIndex } = this
      if (!questions) return []
      return Array(questions.count)
        .fill(null)
        .map((item, index) => ({
          index: index,
          status: index < questionIndex ? 'done' : 'default',
        }))
        .filter((item, index) => {
          const diff = index - questionIndex
          const count = 3
          if (questionIndex < count) return index <= count
          return diff > -count && diff < count
        })
    },
  },
}
</script>

<style lang="sass" scoped>
.headerQuestions
  background-color: #FFFFFF
  padding: 12px 16px 18px
  position: relative
  width: calc(100vw - 32px)
  overflow: hidden
  &::before
    background-color: var(--primaryColor)
    content: ''
    width: 100%
    height: 3px
    opacity: .4
    position: absolute
    top: 28px
    left: 0
    z-index: 0
.categoryItem
  position: absolute
  top: 10px
  left: 16px
  z-index: 2
  &-icon
    background-color: #FFFFFF
    border-radius: 100%
    color: var(--primaryColor)
    width: 2em
    height: 2em
    line-height: 2em
    text-align: center
    font-size: 1.25em

.numberQuestions
  display: inline-flex
  margin-left: 5em
  &-item
    background-color: var(--primaryColorLight)
    border: 2px solid #FFFFFF
      radius: 100%
    color: var(--textHighlightColor)
    font-weight: 500
    width: 1.5em
    height: 1.5em
    line-height: 1.5em
    text-align: center
    margin: 4px 24px
    z-index: 1
    &:first-of-type
      margin-left: 0
    &.done
      background-color: var(--bgColor)
    &.active
      background-color: var(--primaryColor)
      color: #FFF
      display: flex
      flex-direction: column
      align-items: center
.activeText
  display: block
  color: red
  font-size: .4em
  margin-top: -3px
  text-align: center
  text-transform: uppercase
</style>
